/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useWindowSize from '../../hooks/useWindowSize';

import BorderVerticalLarge from '../icons/borders/VerticalLarge';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/event-credits.scss';

const propTypes = {
    id: PropTypes.number.isRequired,
    credits: PropTypes.arrayOf(
        PropTypes.shape({
            role: PropTypes.string,
        }),
    ),
    text: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    credits: [],
    text: null,
    className: null,
};

const EventCredits = ({ id, text, credits, className }) => {
    const { width } = useWindowSize();
    const smallScreen = width < 500;
    const largeScreen = width > 1220;

    const creditsColumn = useMemo(() => {
        if (smallScreen) {
            return [
                credits.slice(0, Math.floor(credits.length / 2)),
                credits.slice(Math.floor(credits.length / 2), credits.length),
            ];
        }
        return [
            credits.slice(0, Math.floor(credits.length / 3)),
            credits.slice(Math.floor(credits.length / 3), Math.floor((credits.length * 2) / 3)),
            credits.slice(Math.floor((credits.length * 2) / 3), credits.length),
        ];
    }, [smallScreen, id]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <BorderVerticalLarge className={styles.border} />
            <div className={styles.inner}>
                {text !== null ? (
                    <div className={styles.text}>
                        <div dangerouslySetInnerHTML={{ __html: text }} />
                    </div>
                ) : null}
                <div className={styles.credits}>
                    {creditsColumn.map((creditsArray, i) => (
                        <div
                            key={`credit-column-${i + 1}`}
                            className={styles.column}
                            style={{ width: smallScreen ? '50%' : largeScreen ? '100%' : '33%' }} //eslint-disable-line
                        >
                            {creditsArray.map((credit, j) => (
                                <div key={`credit-row-${j + 1}`} className={styles.credit}>
                                    <div className={styles.role}>{credit.role}</div>
                                    <div className={styles.people}>
                                        {credit.people.map((person, k) => (
                                            <div
                                                key={`${credits.id}-people-${k + 1}`}
                                                className={styles.person}
                                            >
                                                {person.name}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

EventCredits.propTypes = propTypes;
EventCredits.defaultProps = defaultProps;

export default EventCredits;
